module.exports = function() {
  return new Worker(__webpack_public_path__ + "b056be6eda0be62b0884.worker.js");
};